import { CardDesignTokens } from '@primeuix/themes/types/card';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const cardOverride: CardDesignTokens = {
  root: {
    color: getColor('DarkBlue'),
    borderRadius: getRem(10),
    shadow: `${getRem(0)} ${getRem(1)} ${getRem(3)}
      ${getRem(0)} ${getColor('DarkBlue25')}`,
  },
  body: {
    padding: getRem(12),
  },
};
